/**
 * List of constant resource types for using in application.
 *
 * @module types
 */

'use strict';

/* OLD STUFF todo: remove after refactor
 0 - init screen
 1 - storage
 2 - network
 3 - folder
 4 - file
 // here are subtypes for type 'file'
 */

/*
 0  - init screen
 1  - favorites
 2  - network
 3  - work groups
 4  - servers
 5  - shares | *
 6  - permanent shares

 8  - storage | *
 9  - folder | *
 10 - file | *
 11 - cue | *
 */

var types = {
    fs: [
        'Unknown',
        'FAT16',
        'FAT32',
        'EXT2',
        'EXT3',
        'NTFS',
        'EXT4'
    ],
    media: {
        init: {
            id: 0
        },
        favorite: {
            id: 1,
            opener: null
        },
        network: {
            id: 10
        },
        smb: {
            id: 20,
            opener: null
        },
        smbWorkgroup: 21,
        smbServer: 22,
        smbShare: 23,
        smbPermanentShare: {
            id: 24,
            opener: null
        },
        nfs: {
            id: 30,
            opener: null
        },
        nfsServer: 31,
        nfsShare: 32,
        nfsPermanentShare: {
            id: 33,
            opener: null
        },
        upnp: {
            id: 40,
            opener: null
        },
        upnpServer: 41,
        upnpHost: 42,
        upnpDir: 43,
        folder: {
            id: 50,
            opener: null
        },
        file: 60,
        fileVideo: {
            id: 61,
            icon: 'theme-icon-video',
            opener: null,
            mime: 'content/video',
            extensions: [
                'mpg',
                'mpeg',
                'mov',
                'mp4',
                'avi',
                'mkv',
                '3gp',
                'ts',
                'trp',
                'vob',
                'wmv',
                'mts',
                'm2t',
                'm2v',
                'divx',
                'm2ts',
                'm2p',
                'tp',
                'flv',
                'mod',
                'tod',
                'asf',
                'tts',
                'm4v'
            ]
        },
        fileAudio: {
            id: 62,
            icon: 'theme-icon-audio',
            opener: null,
            mime: 'content/audio',
            extensions: ['mp3', 'wav', 'ac3', 'ogg', 'oga', 'aiff', 'wv', 'tta', 'wma', 'aac', 'dts', 'flac', 'ape', 'm4a']
        },
        fileImage: {
            id: 63,
            icon: 'theme-icon-image',
            opener: null,
            mime: 'content/image',
            extensions: ['jpg', 'jpeg', 'png', 'bmp', 'gif', 'tif', 'tiff']
        },
        fileText: {
            id: 64,
            icon: 'theme-icon-text',
            opener: null,
            extensions: ['txt', 'srt', 'sub', 'ass']
        },
        fileCUE: {
            id: 65,
            icon: 'theme-icon-cue',
            opener: null,
            extensions: ['cue']
        },
        fileISO: {
            id: 66,
            icon: 'theme-icon-iso',
            opener: null,
            mime: 'content/video',
            extensions: ['iso']
        },
        fileRecords: {
            id: 67,
            icon: 'theme-icon-record',
            opener: null,
            extensions: ['tspinf']
        },
        filePlaylist: {
            id: 68,
            icon: 'theme-icon-playlist',
            opener: null,
            extensions: ['m3u', 'm3u8']
        },
        fileStream: {
            id: 69,
            icon: 'theme-icon-stream',
            opener: null,
            mime: 'content/media',
            extensions: ['']
        }
    },
    idToMedia: {}
};

Object.keys(types.media).forEach(function ( key ) {
    types.idToMedia[types.media[key].id] = types.media[key];
});


module.exports = types;
